module.exports = __webpack_public_path__ + "img/approval-gray.054630b4.svg";